var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnocrats2Black(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    width: "0px",
    height: "0px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.627693, 0, 0, 0.627693, -13.245261, -14.406099)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 300 300 L 700 300 L 700 475.022 L 576.021 475.016 C 565.528 443.069 535.458 420 500 420 C 464.546 420 434.477 443.065 423.981 475.009 L 300 475.003 Z M 700 700 L 300 700 L 300 525 L 423.986 525.006 C 434.486 556.942 464.551 580 500 580 C 535.447 580 565.51 556.946 576.012 525.013 L 700 525.019 Z",
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(0, 0, 0)",
      strokeWidth: 30
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "none",
      strokeWidth: 30
    },
    cx: 500,
    cy: 500,
    r: 80
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 60,
    width: 20,
    height: 200,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 30
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 620 260 L 600 260 L 600 180 L 640 180 L 640 100 L 660 100 L 660 200 L 620 200 Z",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 30
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360 100 L 340 100 L 340 180 L 380 180 L 380 260 L 400 260 L 400 160 L 360 160 Z",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 30
    },
    transform: "matrix(-1, 0, 0, -1, 740, 360)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, -1, 0, 1000.744507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 60,
    width: 20,
    height: 200,
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 30
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 620 260 L 600 260 L 600 180 L 640 180 L 640 100 L 660 100 L 660 200 L 620 200 Z",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 30
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360 100 L 340 100 L 340 180 L 380 180 L 380 260 L 400 260 L 400 160 L 360 160 Z",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 30
    },
    transform: "matrix(-1, 0, 0, -1, 740, 360)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0, -1, -1, 0, 1000.69104, 1000.394043)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 60,
    width: 20,
    height: 200,
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 30
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 620 260 L 600 260 L 600 180 L 640 180 L 640 100 L 660 100 L 660 200 L 620 200 Z",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 30
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360 100 L 340 100 L 340 180 L 380 180 L 380 260 L 400 260 L 400 160 L 360 160 Z",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 30
    },
    transform: "matrix(-1, 0, 0, -1, 740, 360)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0, 1, 1, 0, -1.024994, 0.394012)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 60,
    width: 20,
    height: 200,
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 30
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 620 260 L 600 260 L 600 180 L 640 180 L 640 100 L 660 100 L 660 200 L 620 200 Z",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 30
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360 100 L 340 100 L 340 180 L 380 180 L 380 260 L 400 260 L 400 160 L 360 160 Z",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 30
    },
    transform: "matrix(-1, 0, 0, -1, 740, 360)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnocrats2Black);
export default __webpack_public_path__ + "static/media/Technocrats2-Black.cfa784d06bf5a8e9084ada834d16c7d5.svg";
export { ForwardRef as ReactComponent };